import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Dashboard from './views/Dashboard.vue'
import Login from './views/Login.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/media',
      name: 'media',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "media" */ './views/Media.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/articoli',
      name: 'articoli',
      component: () => import( /* webpackChunkName: "articoli" */ './views/Articoli.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/gestione-accessori',
      name: 'gentione-accessori',
      component: () => import( /* webpackChunkName: "gestione-accessori" */ './views/GestioneAccessori.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/registro-generale',
      name: 'registro-generale',
      component: () => import( /* webpackChunkName: "registro-generale" */ './views/RegistroGenerale.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/storico-vendite',
      name: 'storico-vendite',
      component: () => import( /* webpackChunkName: "storico-vendite" */ './views/StoricoVendite.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/note',
      name: 'note',
      component: () => import( /* webpackChunkName: "note" */ './views/Note.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/clienti',
      name: 'clienti',
      component: () => import( /* webpackChunkName: "clienti" */ './views/Clienti.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/magazzino/smartphones',
      name: 'magazzino-smartphones',
      component: () => import( /* webpackChunkName: "magazzino-smartphones" */ './views/MagazzinoSmartphones.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/magazzino/sims',
      name: 'magazzino-sims',
      component: () => import( /* webpackChunkName: "magazzino-sims" */ './views/MagazzinoSims.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/magazzino/accessori',
      name: 'magazzino-accessori',
      component: () => import( /* webpackChunkName: "magazzino-accessori" */ './views/MagazzinoAccessori.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/magazzino/ricambi',
      name: 'magazzino-ricambi',
      component: () => import( /* webpackChunkName: "magazzino-ricambi" */ './views/MagazzinoRicambi.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/magazzino/servizi',
      name: 'magazzino-servizi',
      component: () => import( /* webpackChunkName: "magazzino-servizi" */ './views/MagazzinoServizi.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/magazzino/formazione',
      name: 'magazzino-formazione',
      component: () => import( /* webpackChunkName: "magazzino-formazione" */ './views/MagazzinoFormazione.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/riparazioni/bytewood',
      name: 'riparazioni-bytewood',
      component: () => import( /* webpackChunkName: "riparazioni-bytewood" */ './views/RiparazioniBytewood.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/riparazioni/clienti',
      name: 'riparazioni-clienti',
      component: () => import( /* webpackChunkName: "riparazioni-clienti" */ './views/RiparazioniClienti.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/usato/clienti',
      name: 'usato-clienti',
      component: () => import( /* webpackChunkName: "usato-clienti" */ './views/UsatoClienti.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/preordini/devices',
      name: 'preordini-devices',
      component: () => import( /* webpackChunkName: "preordini" */ './views/Preordini.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/preordini/accessori',
      name: 'preordini-accessori',
      component: () => import( /* webpackChunkName: "preordini" */ './views/Preordini.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/preordini/ricambi',
      name: 'preordini-ricambi',
      component: () => import( /* webpackChunkName: "preordini" */ './views/Preordini.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/movimenti',
      name: 'movimenti',
      component: () => import( /* webpackChunkName: "movimenti" */ './views/Movimenti.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/categorie',
      name: 'categorie',
      component: () => import( /* webpackChunkName: "categorie" */ './views/Categorie.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/strumenti-di-contabilita',
      name: 'strumenti-di-contabilita',
      component: () => import( /* webpackChunkName: "strumenti-di-contabilita" */ './views/StrumentiContabilita.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/camere',
      name: 'camere',
      component: () => import( /* webpackChunkName: "camere" */ './views/Cams.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/profilo',
      name: 'profilo',
      component: () => import( /* webpackChunkName: "profilo" */ './views/Profilo.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {

  // const {
  //   uri
  // } = to.query;
  // if (uri != null && uri != '/') {
  //   next(false);
  //   router.push(uri);
  // } else {
  //   next();
  // }

  if (to.meta.requiresAuth) {
    if (store.getters.isLogged) {
      next()
    } else {
      next('/login')
    }
  } else {
    if (!store.getters.isLogged) {
      next()
    } else {
      next('/')
    }
  }
})

export default router